/* eslint-disable array-callback-return */
/* eslint-disable no-useless-rename */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
/* eslint-disable no-template-curly-in-string */

//ran this thru claudes code refactoring tool


// redesign this component to look more elegant and polished and accents
// use tailwind css in the className directive 
// give me the entire code to copy any insrtuctions to implement
// ask me a series of questions to gather additional context you need to best achive this task

// do not change any functionality
// use tailwind css in the className directive 
// Use Tailwind CSS className only. Preserve all logic, Redux hooks, and routing exactly as-is.

// ask me a series of questions to gather additional context you need to best achive this task
// Give me the complete code with instructions


// add coupon to the total if the coupon is valid
// create subtotal 
// the logic is this: isCouponValid = Boolean(eventDetailsInfo?.coupon) && (!eventDetailsInfo?.couponExpirationDate || new Date(eventDetailsInfo?.couponExpirationDate) > new Date());
// COUPONS can a percentage or an amount ['5% Off', '10% Off', '15% Off', '20% Off', '25% Off', '30% Off', '35% Off', '40% Off', '45% Off', 
//       '50% Off', '$25 Off', '$50 Off', '$75 Off', '$100 Off', '$150 Off', '$200 Off', '$250 Off', '$300 Off', '$400 Off', 
//       '$500 Off', '$600 Off', '$700 Off', '$800 Off', '$900 Off', '$1000 Off', '$1500 Off', '$2000 Off', '$2500 Off'], 
// give me the entire code to copy    



import React, { useEffect, useCallback, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';

import { IoIosArrowForward } from "react-icons/io";
import { TbListDetails } from "react-icons/tb";
import { MdOutlineRestaurantMenu } from "react-icons/md";
import { FiShoppingCart } from "react-icons/fi";
import { FaRegTrashAlt, FaRegHeart } from "react-icons/fa";
import { RiShoppingCartLine } from "react-icons/ri";
import { BiSolidCoupon } from "react-icons/bi";

import Header from '../components/Header';
import Footer from '../components/Footer';
import ShopBanner from '../components/ShopBanner';
import CartProduct from '../components/CartProduct';
import Accordion from '../components/Accordion';
import GetSellerConfig from '../components/GetSellerConfig';
import SiteBadge from '../components/SiteBadge';

import {
    get_cart_products,
    get_wishlist_products,
    delete_cart_product,
    messageClear,
    cart_product_quantity_increment,
    move_from_cart_to_wishlist,
    cart_product_quantity_decrement,
    cart_product_portion_size_change,
    cart_product_event_part_change,
} from '../store/reducers/cartReducer';

import { get_event_details } from '../store/reducers/eventDetailsReducer';
import { get_one_sellerPackage } from '../store/reducers/sellerPackageReducer';

import { currencyFormat } from '../components/CurrencyFormat';
import DiagnosticInfo from '../components/DiagnosticInfo';
import Moment from 'moment';

import toast from 'react-hot-toast';
import config from '../config';

// ─── Coupon helpers ────────────────────────────────────────────────────────
// Coupons look like '5% Off', '10% Off', ... or '$25 Off', '$50 Off', ...
const parseCoupon = (coupon) => {
    if (!coupon || typeof coupon !== 'string') return null;

    const trimmed = coupon.trim();

    if (trimmed.includes('%')) {
        const value = parseFloat(trimmed);
        if (isNaN(value)) return null;
        return { type: 'percent', value };
    }

    if (trimmed.includes('$')) {
        const value = parseFloat(trimmed.replace(/[^0-9.]/g, ''));
        if (isNaN(value)) return null;
        return { type: 'amount', value };
    }

    return null;
};

// Given a subtotal and a coupon string, returns the discount amount (never more than the subtotal)
const calculateCouponDiscount = (subtotal, coupon) => {
    const parsed = parseCoupon(coupon);
    if (!parsed || !subtotal) return 0;

    if (parsed.type === 'percent') {
        const discount = (subtotal * parsed.value) / 100;
        return Math.min(discount, subtotal);
    }

    // flat amount
    return Math.min(parsed.value, subtotal);
};

const Cart = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    // ─── Config ────────────────────────────────────────────────────────────────
    const sellerFrontendURL = config.STR_FRONTEND_URL;
    const sellerEnvironment = config.STR_ENVIRONMENT;
    const sellerBoolShowOutOfStock = config.BOOL_SHOW_PRODUCT_OUT_OF_STOCK;

    // ─── Redux state ───────────────────────────────────────────────────────────
    const { seller } = useSelector(state => state.seller);
    const { userInfo } = useSelector(state => state.auth);
    const {
        cart_products,
        successMessage,
        errorMessage,
        buy_product_item,
        price,
        shipping_fee,
        outofstock_products,
    } = useSelector(state => state.cart);

    const { eventDetails } = useSelector(state => state.eventDetails);
    const { sellerPackage } = useSelector(state => state.sellerPackage);

    const isCouponValid = Boolean(eventDetails?.coupon) && (!eventDetails?.couponExpirationDate || new Date(eventDetails?.couponExpirationDate) > new Date());

    const isCouponExpired = eventDetails?.couponExpirationDate !== undefined && eventDetails?.couponExpirationDate !== ''
        ? true : false;

    const {
        sellerId,
        sellerPrimaryColor1, sellerPrimaryColor2, sellerSecondaryColor1, sellerSecondaryColor2,
        sellerColorSuffixDark, sellerColorSuffixMedium, sellerColorSuffixLight, sellerComponentBackgroundColor,
        sellerProductPluralTerm, sellerBoolShowSitePayments, sellerBoolShowQuantities, sellerBoolShowCuisineType,
    } = GetSellerConfig();

    // ─── Derived values ────────────────────────────────────────────────────────
    // subtotal = raw cart price before any coupon or deposit adjustments
    const subtotal = price ?? 0;

    // coupon discount amount, computed from subtotal so % coupons are correct
    const couponDiscount = useMemo(() => {
        if (!isCouponValid) return 0;
        return calculateCouponDiscount(subtotal, eventDetails?.coupon);
    }, [isCouponValid, subtotal, eventDetails?.coupon]);

    // subtotal after coupon, before deposit
    const priceAfterCoupon = Math.max(subtotal - couponDiscount, 0);

    // final total: apply deposit on top of the coupon-adjusted price
    const finalPrice = eventDetails?.depositGiven
        ? priceAfterCoupon - (eventDetails?.depositAmountPaid ?? 0)
        : priceAfterCoupon;

    // Category counts rendered as React elements (no dangerouslySetInnerHTML)
    const categoryCounts = useMemo(() => {
        const products = cart_products[0]?.products ?? [];
        const counts = products.reduce((acc, product) => {
            const cat = product.productInfo?.category ?? 'Unknown';
            acc[cat] = (acc[cat] || 0) + 1;
            return acc;
        }, {});
        return Object.entries(counts).sort(([a], [b]) => a.localeCompare(b));
    }, [cart_products]);

    // ─── Sort mode ─────────────────────────────────────────────────────────────
    const SORT_OPTIONS = [
        { value: 'category_name', label: 'Category, Name' },
        { value: 'name_category', label: 'Name, Category' },
        { value: 'eventpart_name', label: 'Event Part, Name' },
    ];
    const [sortMode, setSortMode] = useState('category_name');

    const sortedProducts = useMemo(() => {
        return [...(cart_products[0]?.products ?? [])].sort((a, b) => {
            const nameA = a.productInfo?.name ?? '';
            const nameB = b.productInfo?.name ?? '';
            const catA = a.productInfo?.category ?? '';
            const catB = b.productInfo?.category ?? '';
            const evtA = a.eventPart ?? '';
            const evtB = b.eventPart ?? '';

            if (sortMode === 'category_name') {
                return catA !== catB ? catA.localeCompare(catB) : nameA.localeCompare(nameB);
            }
            if (sortMode === 'name_category') {
                return nameA !== nameB ? nameA.localeCompare(nameB) : catA.localeCompare(catB);
            }
            if (sortMode === 'eventpart_name') {
                return evtA !== evtB ? evtA.localeCompare(evtB) : nameA.localeCompare(nameB);
            }
            return 0;
        });
    }, [cart_products, sortMode]);

    // ─── Effects ───────────────────────────────────────────────────────────────
    useEffect(() => {
        dispatch(get_event_details(userInfo.id));
    }, [userInfo.id, dispatch]);

    useEffect(() => {
        dispatch(get_cart_products(userInfo.id));
    }, [dispatch, sellerFrontendURL, userInfo.id]);

    useEffect(() => {
        if (eventDetails?.selectedSellerPackage) {
            dispatch(get_one_sellerPackage({
                title: eventDetails.selectedSellerPackage,
                webSiteOrigin: sellerFrontendURL,
            }));
        }
    }, [eventDetails?.selectedSellerPackage, sellerFrontendURL, dispatch]);

    const EmptyShoppingCart = ({ sellerPrimaryColor1, sellerProductPluralTerm }) => (
        <div className='flex flex-col border rounded-2xl items-center justify-center py-24 sm:py-14 gap-5'
            style={{
                backgroundColor: sellerPrimaryColor1 + sellerColorSuffixLight,
                borderColor: sellerPrimaryColor1 + sellerColorSuffixDark,
            }}>
            <div className='flex gap-5 p-5 rounded-full' style={{ backgroundColor: sellerPrimaryColor1 + sellerColorSuffixLight }}>
                <RiShoppingCartLine size={40} style={{ color: sellerPrimaryColor1 + sellerColorSuffixDark }} />
                <MdOutlineRestaurantMenu size={40} style={{ color: sellerPrimaryColor1 + sellerColorSuffixDark }} />
            </div>
            <p className='text-lg font-medium tracking-wide text-center px-4' style={{ color: sellerPrimaryColor1 + sellerColorSuffixDark }}>
                My {sellerProductPluralTerm} Is Empty
            </p>
            <div className='flex flex-col sm:w-full sm:px-6 md:flex-row gap-3 mt-2'>
                <Link
                    to='/'
                    className='px-6 py-2.5 rounded-full text-white text-sm font-medium tracking-wide transition-opacity duration-200 hover:opacity-90 text-center'
                    style={{ backgroundColor: sellerPrimaryColor1 + sellerColorSuffixDark }}>
                    Back To Home Page
                </Link>
                <Link
                    to='/shops'
                    className='px-6 py-2.5 rounded-full text-sm font-medium tracking-wide transition-colors duration-200 text-center border'
                    style={{
                        borderColor: sellerPrimaryColor1 + sellerColorSuffixDark,
                        color: sellerPrimaryColor1 + sellerColorSuffixDark,
                    }}>
                    Browse {sellerProductPluralTerm}
                </Link>
            </div>
        </div>
    );

    useEffect(() => {
        if (successMessage) {
            toast.success(successMessage);
            dispatch(messageClear());
            dispatch(get_cart_products(userInfo.id));
        }
        if (errorMessage) {
            toast.error(errorMessage);
            dispatch(messageClear());
        }
    }, [successMessage, errorMessage, dispatch, userInfo.id]);

    // ─── Handlers ──────────────────────────────────────────────────────────────
    const handleDeleteAll = useCallback(() => {
        if (!userInfo) { navigate('/login'); return; }
        (cart_products[0]?.products ?? []).forEach(p => dispatch(delete_cart_product(p._id)));
    }, [userInfo, cart_products, dispatch, navigate]);

    const handleMoveToWishlist = useCallback((id) => {
        if (!userInfo) { navigate('/login'); return; }
        dispatch(move_from_cart_to_wishlist(id));
        dispatch(get_cart_products(userInfo.id));
        dispatch(get_wishlist_products(userInfo.id));
    }, [userInfo, dispatch, navigate]);

    const handleQuantityIncrement = useCallback((quantity, stock, cart_id) => {
        if (quantity + 1 <= stock) dispatch(cart_product_quantity_increment(cart_id));
    }, [dispatch]);

    const handleQuantityDecrement = useCallback((quantity, cart_id) => {
        if (quantity - 1 !== 0) dispatch(cart_product_quantity_decrement(cart_id));
    }, [dispatch]);

    const handlePortionSizeChange = useCallback((cart_id, newPortionSize) => {
        dispatch(cart_product_portion_size_change({ cart_id, newPortionSize }));
    }, [dispatch]);

    const handleEventPartChange = useCallback((cart_id, newEventPart) => {
        dispatch(cart_product_event_part_change({ cart_id, newEventPart }));
    }, [dispatch]);

    const redirect = useCallback(() => {
        navigate('/eventDetails', {
            state: {
                products: cart_products,
                price,
                shipping_fee,
                items: buy_product_item,
            },
        });
    }, [navigate, cart_products, price, shipping_fee, buy_product_item]);

    // ─── Render ────────────────────────────────────────────────────────────────
    const hasItems = cart_products.length > 0 || outofstock_products?.length > 0;

    return (
        <div>
            <Header />
            <section className=''>
                <div className=''>
                    <div className=''>
                        <ShopBanner
                            homePage={'Home'} homeLink={'/'}
                            currentPageTop={`My ${sellerProductPluralTerm}`} currentPageTopLink={''}
                            currentPageBottom1={`My ${sellerProductPluralTerm}`} currentPageBottomLink1={''}
                            currentPageBottom2={''} currentPageBottomLink2={''}
                        />
                    </div>
                    {/* ── body start ── */}
                    <div className='' style={{ backgroundColor: sellerComponentBackgroundColor }}>
                        <div className='bg-white rounded-2xl w-[85%] lg:w-[90%] md:w-[90%] sm:w-[95%] mx-auto py-0'>
                            {hasItems ? (
                                <div className='border rounded-2xl p-3 flex md-lg:flex-col flex-wrap pt-6 sm:pt-4 gap-6 md-lg:gap-4'
                                    style={{
                                        backgroundColor: sellerPrimaryColor1 + sellerColorSuffixLight,
                                        borderColor: sellerPrimaryColor1 + sellerColorSuffixDark
                                    }}>
                                    {/* ── Left: Cart items ── */}
                                    <div className='flex-1 min-w-0 md-lg:w-full'>
                                        <div className='flex flex-col gap-4'>
                                            <div className='bg-white rounded-2xl border p-5 sm:p-3'
                                                style={{
                                                    borderLeft: `6px solid ${sellerPrimaryColor1 + sellerColorSuffixDark}`,
                                                    borderColor: sellerPrimaryColor1 + sellerColorSuffixDark,
                                                }}>
                                                <DiagnosticInfo parentPage={'Cart.jsx'} />
                                                {/* Header row */}
                                                <div className='w-full flex md:flex-col items-start md:items-stretch justify-between gap-4 pb-5 mb-5 border-b border-gray-100'>
                                                    <div className='flex flex-col gap-2'>
                                                        <div className='text-2xl md:text-xl font-semibold tracking-tight flex items-center gap-2 flex-wrap'
                                                            style={{ color: sellerPrimaryColor1 + sellerColorSuffixDark }}>
                                                            <SiteBadge iconType={'Menu'} iconSize={'24'} badgeSize={'32'} />
                                                            <span>My Menu</span>
                                                            <span className='text-sm font-normal'
                                                                style={{ color: sellerPrimaryColor1 + sellerColorSuffixMedium }}>
                                                                · {buy_product_item} {sellerProductPluralTerm}
                                                            </span>
                                                        </div>
                                                        {/* Sort dropdown */}
                                                        <div className='flex items-center gap-2 text-sm'>
                                                            <span className='font-medium whitespace-nowrap'
                                                                style={{ color: sellerPrimaryColor1 + sellerColorSuffixMedium }}>
                                                                Sort by
                                                            </span>
                                                            <select
                                                                value={sortMode}
                                                                onChange={(e) => setSortMode(e.target.value)}
                                                                className='text-sm h-9 px-3 rounded-lg font-medium border border-gray-200 bg-white cursor-pointer focus:outline-none focus:ring-2 transition-shadow'
                                                                style={{
                                                                    color: sellerPrimaryColor1 + sellerColorSuffixDark,
                                                                    backgroundColor: sellerPrimaryColor1 + sellerColorSuffixLight,
                                                                    borderColor: sellerPrimaryColor1 + sellerColorSuffixDark
                                                                }}>
                                                                {SORT_OPTIONS.map(opt => (
                                                                    <option key={opt.value} value={opt.value}>{opt.label}</option>
                                                                ))}
                                                            </select>
                                                        </div>
                                                    </div>
                                                    <button
                                                        onClick={handleDeleteAll}
                                                        className='bg-red-500 gap-1 m-1 text-white text-center items-center 
                                                            justify-center justify-items-center rounded-md px-3 py-1 flex ml-auto md:ml-0'>
                                                        <MdOutlineRestaurantMenu size={24} className='mt-0.5 mr-0.5' /> Clear My Menu
                                                    </button>
                                                </div>

                                                {/* Selected package accordion */}
                                                {eventDetails?.selectedSellerPackage && eventDetails.selectedSellerPackage !== 'None' && (
                                                    <div className='mb-5 rounded-xl border overflow-hidden'
                                                        style={{
                                                            borderColor: sellerPrimaryColor1 + sellerColorSuffixLight,
                                                            color: sellerPrimaryColor1 + sellerColorSuffixDark,
                                                            backgroundColor: sellerPrimaryColor1 + sellerColorSuffixLight
                                                        }}>
                                                        <Accordion
                                                            title={sellerPackage?.title}
                                                            intro={sellerPackage?.intro}
                                                            pricePerPerson={sellerPackage?.pricePerPerson}
                                                            minNumberPeople={sellerPackage?.minNumberPeople}
                                                            description={sellerPackage?.description}
                                                            showSetSellerPackageButton={false}
                                                        />
                                                    </div>
                                                )}

                                                {/* Product cards */}
                                                {cart_products.map((p, i) => (
                                                    <div
                                                        key={p._id ?? i}
                                                        className='grid grid-cols-2 md-lg:grid-cols-1 gap-3'>
                                                        {sortedProducts.map((pt) => (
                                                            <CartProduct
                                                                key={pt._id}
                                                                pt={pt}
                                                                onQuantityIncrement={handleQuantityIncrement}
                                                                onQuantityDecrement={handleQuantityDecrement}
                                                                onPortionSizeChange={handlePortionSizeChange}
                                                                onEventPartChange={handleEventPartChange}
                                                                onMoveToWishlist={handleMoveToWishlist}
                                                            />
                                                        ))}
                                                    </div>
                                                ))}
                                            </div>

                                            {/* Out of stock */}
                                            {outofstock_products?.length > 0 && sellerBoolShowOutOfStock && (
                                                <div className='bg-white rounded-2xl border border-gray-100 shadow-sm overflow-hidden'>
                                                    <div className='px-5 sm:px-3 py-4 border-b border-gray-100'>
                                                        <h2 className='text-base font-semibold' style={{ color: sellerPrimaryColor1 }}>
                                                            Out of Stock <span className='text-gray-400 font-normal'>({outofstock_products.length})</span>
                                                        </h2>
                                                    </div>
                                                    <div className='divide-y divide-gray-100'>
                                                        {outofstock_products.map((p, i) => (
                                                            <div key={p._id ?? i} className='w-full flex flex-wrap items-center px-5 sm:px-3 py-4'>
                                                                <div className='flex sm:w-full gap-3 w-7/12 items-center'>
                                                                    <img
                                                                        className='w-[64px] h-[64px] sm:w-[52px] sm:h-[52px] rounded-lg object-cover border border-gray-100 shrink-0'
                                                                        src={p.products[0].images[0]}
                                                                        alt={p.products[0].name}
                                                                    />
                                                                    <div style={{ color: sellerPrimaryColor1 }}>
                                                                        <h2 className='text-sm font-semibold'>{p.products[0].name}</h2>
                                                                        <span className='text-xs text-gray-400'>Brand: {p.products[0].brand}</span>
                                                                    </div>
                                                                </div>
                                                                <div className='flex justify-between items-center w-5/12 sm:w-full sm:flex-col-reverse sm:items-stretch sm:gap-3 sm:mt-3'>
                                                                    <h2 className='text-base font-medium' style={{ color: sellerPrimaryColor1 }}>
                                                                        {currencyFormat.format(
                                                                            p.products[0].price -
                                                                            Math.floor((p.products[0].price * p.products[0].discount) / 100)
                                                                        )}
                                                                    </h2>
                                                                    <div className='flex gap-2 items-center sm:justify-between'>
                                                                        <div className='flex bg-gray-50 rounded-lg h-8 items-center text-base border border-gray-100'>
                                                                            <div
                                                                                onClick={() => handleQuantityDecrement(p.quantity, p._id)}
                                                                                className='px-3 cursor-pointer select-none'
                                                                                style={{ color: sellerPrimaryColor1 }}
                                                                            >−</div>
                                                                            <div className='px-2 text-sm font-medium' style={{ color: sellerPrimaryColor1 }}>{p.quantity}</div>
                                                                            <div
                                                                                onClick={() => handleQuantityIncrement(p.quantity, p.productInfo?.stock, p._id)}
                                                                                className='px-3 cursor-pointer select-none'
                                                                                style={{ color: sellerPrimaryColor1 }}
                                                                            >+</div>
                                                                        </div>
                                                                        <button
                                                                            onClick={() => dispatch(delete_cart_product(p._id))}
                                                                            className='px-4 py-1.5 text-sm text-white rounded-lg transition-opacity hover:opacity-90'
                                                                            style={{ backgroundColor: sellerPrimaryColor1 }}>
                                                                            Delete
                                                                        </button>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        ))}
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                    </div>

                                    {/* ── Right: Summary sidebar ── */}
                                    <div className='w-[340px] lg:w-[320px] md-lg:w-full'>
                                        {cart_products.length > 0 && (
                                            <div className='md-lg:static sticky top-4 bg-white rounded-2xl border border-gray-100 
                                                shadow-sm p-5 sm:p-3 flex flex-col gap-4'
                                                style={{
                                                    borderLeft: `6px solid ${sellerPrimaryColor1 + sellerColorSuffixDark}`,
                                                    borderColor: sellerPrimaryColor1 + sellerColorSuffixDark,
                                                }}>
                                                <div className='flex items-center gap-2 text-[24px] font-semibold tracking-tight pb-4 border-b border-gray-100'
                                                    style={{ color: sellerPrimaryColor1 + sellerColorSuffixDark }}>
                                                    <MdOutlineRestaurantMenu size={32} /> Menu Summary
                                                </div>

                                                {/* Item count */}
                                                <div className='flex justify-between items-center text-sm'>
                                                    <div className='text-gray-500'
                                                        style={{ color: sellerPrimaryColor1 + sellerColorSuffixDark }}>
                                                        <span className='font-semibold mr-1'>
                                                            {buy_product_item}
                                                        </span>
                                                        {sellerProductPluralTerm}
                                                    </div>
                                                </div>

                                                {/* Category counts */}
                                                <div className='text-xs text-gray-400 leading-relaxed'
                                                    style={{ color: sellerPrimaryColor1 + sellerColorSuffixMedium }}>
                                                    {categoryCounts.map(([cat, count], i) => (
                                                        <span key={cat}>
                                                            <strong className=''>
                                                                {count}</strong> {cat}{i < categoryCounts.length - 1 ? ', ' : ''}
                                                        </span>
                                                    ))}
                                                </div>

                                                {sellerBoolShowSitePayments && (
                                                    <>
                                                        {/* Subtotal */}
                                                        <div className='flex justify-between items-center text-sm pt-2 border-t border-gray-100'
                                                            style={{ color: sellerPrimaryColor1 + sellerColorSuffixDark }}>
                                                            <span>Subtotal</span>
                                                            <span className='font-medium'>{currencyFormat.format(subtotal)}</span>
                                                        </div>

                                                        {/* Coupon line */}
                                                        {isCouponValid && couponDiscount > 0 && (
                                                            <div className='flex flex-col gap-1'>
                                                                <div className='flex justify-between items-center text-sm text-green-600'>
                                                                    <span className='flex items-center gap-1'>
                                                                        <BiSolidCoupon size={16} />
                                                                        Coupon {eventDetails?.coupon}
                                                                        {eventDetails?.couponDescription ? ` — ${eventDetails.couponDescription}` : ''}
                                                                    </span>
                                                                    <span className='font-medium'>
                                                                        −{currencyFormat.format(couponDiscount)}
                                                                    </span>
                                                                </div>
                                                                {eventDetails?.couponExpirationDate && (
                                                                    <div className='text-xs text-gray-400 pl-5'>
                                                                        Expires: {Moment(eventDetails.couponExpirationDate).format('MM/DD/YYYY')}
                                                                    </div>
                                                                )}
                                                            </div>
                                                        )}

                                                        {/* Deposit line */}
                                                        {eventDetails?.depositGiven && (
                                                            <div className='flex justify-between items-center text-sm text-gray-500'>
                                                                <span>Deposit</span>
                                                                <span>−{currencyFormat.format(eventDetails?.depositAmountPaid)}</span>
                                                            </div>
                                                        )}

                                                        {/* Total */}
                                                        <div className='flex justify-between items-center pt-2 border-t border-gray-100'>
                                                            <span className='text-base font-semibold' style={{ color: sellerPrimaryColor1 + sellerColorSuffixDark }}>Total</span>
                                                            <span className='text-base font-semibold' style={{ color: sellerPrimaryColor1 + sellerColorSuffixDark }}>
                                                                {currencyFormat.format(finalPrice)}
                                                            </span>
                                                        </div>
                                                    </>
                                                )}

                                                <button
                                                    onClick={redirect}
                                                    className='mt-1 w-full inline-flex items-center justify-center gap-2 rounded-xl text-base font-medium text-white py-3 transition-opacity duration-200 hover:opacity-90'
                                                    style={{ backgroundColor: sellerPrimaryColor1 + sellerColorSuffixDark }}>
                                                    <TbListDetails size={18} /> Proceed to Event Details
                                                </button>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            ) : (
                                <div>
                                    <EmptyShoppingCart
                                        sellerPrimaryColor1={sellerPrimaryColor1}
                                        sellerProductPluralTerm={sellerProductPluralTerm}
                                    />
                                </div>
                            )}
                        </div>
                    </div>
                </div>
                {/* ── body end ── */}
            </section>
            <Footer />
        </div>
    );
};

export default Cart;






// import React, { useEffect, useCallback, useMemo, useState } from 'react';
// import { useDispatch, useSelector } from 'react-redux';
// import { Link, useNavigate } from 'react-router-dom';

// import { IoIosArrowForward } from "react-icons/io";
// import { TbListDetails } from "react-icons/tb";
// import { MdOutlineRestaurantMenu } from "react-icons/md";
// import { FiShoppingCart } from "react-icons/fi";
// import { FaRegTrashAlt, FaRegHeart } from "react-icons/fa";
// import { RiShoppingCartLine } from "react-icons/ri";
// import { BiSolidCoupon } from "react-icons/bi";

// import Header from '../components/Header';
// import Footer from '../components/Footer';
// import ShopBanner from '../components/ShopBanner';
// import CartProduct from '../components/CartProduct';
// import Accordion from '../components/Accordion';
// import GetSellerConfig from '../components/GetSellerConfig';
// import SiteBadge from '../components/SiteBadge';

// import {
//     get_cart_products,
//     get_wishlist_products,
//     delete_cart_product,
//     messageClear,
//     cart_product_quantity_increment,
//     move_from_cart_to_wishlist,
//     cart_product_quantity_decrement,
//     cart_product_portion_size_change,
//     cart_product_event_part_change,
// } from '../store/reducers/cartReducer';

// import { get_event_details } from '../store/reducers/eventDetailsReducer';
// import { get_one_sellerPackage } from '../store/reducers/sellerPackageReducer';

// import { currencyFormat } from '../components/CurrencyFormat';
// import DiagnosticInfo from '../components/DiagnosticInfo';
// import Moment from 'moment';

// import toast from 'react-hot-toast';
// import config from '../config';

// const Cart = () => {
//     const dispatch = useDispatch();
//     const navigate = useNavigate();

//     // ─── Config ────────────────────────────────────────────────────────────────
//     const sellerFrontendURL = config.STR_FRONTEND_URL;
//     const sellerEnvironment = config.STR_ENVIRONMENT;
//     const sellerBoolShowOutOfStock = config.BOOL_SHOW_PRODUCT_OUT_OF_STOCK;

//     // ─── Redux state ───────────────────────────────────────────────────────────
//     const { seller } = useSelector(state => state.seller);
//     const { userInfo } = useSelector(state => state.auth);
//     const {
//         cart_products,
//         successMessage,
//         errorMessage,
//         buy_product_item,
//         price,
//         shipping_fee,
//         outofstock_products,
//     } = useSelector(state => state.cart);

//     const { eventDetails } = useSelector(state => state.eventDetails);
//     //console.log('eventDetails ', eventDetails)
//     const { sellerPackage } = useSelector(state => state.sellerPackage);
//     const isCouponValid = Boolean(eventDetails?.coupon) && (!eventDetails?.couponExpirationDate || new Date(eventDetails?.couponExpirationDate) > new Date());
//     //Moment(eventDetails?.couponExpirationDate, 'MM/DD/yyyy') !== 'Invalid Date'

//     const isCouponExpired = eventDetails?.couponExpirationDate !== undefined && eventDetails?.couponExpirationDate !== ''
//         ? true  : false;
    
//     //new Date(eventDetails?.couponExpirationDate) < new Date()
//     //console.log(new Date(eventDetails?.couponExpirationDate) < new Date())
//     //console.log('isCouponExpired\n', isCouponExpired, eventDetails?.couponExpirationDate)
//     //console.log('isCouponExpired\n', isCouponExpired, '\n', Moment(eventDetails?.couponExpirationDate, 'MM/DD/yyyy'))
    
//     //&& eventDetails?.couponExpirationDate 
//     //const isCouponExpired = eventDetails?.couponExpirationDate && eventDetails.couponExpirationDate !== '' 
//         // && eventDetails?.couponExpirationDate !== undefined
//         // ? new Date(eventDetails.couponExpirationDate) < new Date()
//         // : false;

//     const { 
//         sellerId, 
//         sellerPrimaryColor1, sellerPrimaryColor2, sellerSecondaryColor1, sellerSecondaryColor2,
//         sellerColorSuffixDark, sellerColorSuffixMedium, sellerColorSuffixLight, sellerComponentBackgroundColor,
//         sellerProductPluralTerm, sellerBoolShowSitePayments, sellerBoolShowQuantities, sellerBoolShowCuisineType,
//     } = GetSellerConfig();

//     // ─── Derived values ────────────────────────────────────────────────────────
//     const finalPrice = eventDetails?.depositGiven
//         ? price - (eventDetails?.depositAmountPaid ?? 0)
//         : price;

//     // Category counts rendered as React elements (no dangerouslySetInnerHTML)
//     const categoryCounts = useMemo(() => {
//         const products = cart_products[0]?.products ?? [];
//         const counts = products.reduce((acc, product) => {
//             const cat = product.productInfo?.category ?? 'Unknown';
//             acc[cat] = (acc[cat] || 0) + 1;
//             return acc;
//         }, {});
//         return Object.entries(counts).sort(([a], [b]) => a.localeCompare(b));
//     }, [cart_products]);

//     // ─── Sort mode ─────────────────────────────────────────────────────────────
//     const SORT_OPTIONS = [
//         { value: 'category_name', label: 'Category, Name' },
//         { value: 'name_category', label: 'Name, Category' },
//         { value: 'eventpart_name', label: 'Event Part, Name' },
//     ];
//     const [sortMode, setSortMode] = useState('category_name');

//     const sortedProducts = useMemo(() => {
//         return [...(cart_products[0]?.products ?? [])].sort((a, b) => {
//             const nameA = a.productInfo?.name ?? '';
//             const nameB = b.productInfo?.name ?? '';
//             const catA  = a.productInfo?.category ?? '';
//             const catB  = b.productInfo?.category ?? '';
//             const evtA  = a.eventPart ?? '';
//             const evtB  = b.eventPart ?? '';

//             if (sortMode === 'category_name') {
//                 return catA !== catB ? catA.localeCompare(catB) : nameA.localeCompare(nameB);
//             }
//             if (sortMode === 'name_category') {
//                 return nameA !== nameB ? nameA.localeCompare(nameB) : catA.localeCompare(catB);
//             }
//             if (sortMode === 'eventpart_name') {
//                 return evtA !== evtB ? evtA.localeCompare(evtB) : nameA.localeCompare(nameB);
//             }
//             return 0;
//         });
//     }, [cart_products, sortMode]);

//     // ─── Effects ───────────────────────────────────────────────────────────────
//     useEffect(() => {
//         dispatch(get_event_details(userInfo.id));
//     }, [userInfo.id, dispatch]);

//     useEffect(() => {
//         dispatch(get_cart_products(userInfo.id));
//     }, [dispatch, sellerFrontendURL, userInfo.id]);

//     useEffect(() => {
//         if (eventDetails?.selectedSellerPackage) {
//             dispatch(get_one_sellerPackage({
//                 title: eventDetails.selectedSellerPackage,
//                 webSiteOrigin: sellerFrontendURL,
//             }));
//         }
//     }, [eventDetails?.selectedSellerPackage, sellerFrontendURL, dispatch]);

//     const EmptyShoppingCart = ({ sellerPrimaryColor1, sellerProductPluralTerm }) => (
//         <div className='flex flex-col border rounded-2xl items-center justify-center py-24 sm:py-14 gap-5'
//             style={{ 
//                 backgroundColor: sellerPrimaryColor1 + sellerColorSuffixLight,
//                 borderColor: sellerPrimaryColor1 + sellerColorSuffixDark,
//             }}>
//             <div className='flex gap-5 p-5 rounded-full' style={{ backgroundColor: sellerPrimaryColor1 + sellerColorSuffixLight }}>
//                 <RiShoppingCartLine size={40} style={{ color: sellerPrimaryColor1 + sellerColorSuffixDark }} />
//                 <MdOutlineRestaurantMenu size={40} style={{ color: sellerPrimaryColor1 + sellerColorSuffixDark }} />
//             </div>
//             <p className='text-lg font-medium tracking-wide text-center px-4' style={{ color: sellerPrimaryColor1 + sellerColorSuffixDark }}>
//                 My {sellerProductPluralTerm} Is Empty
//             </p>
//             <div className='flex flex-col sm:w-full sm:px-6 md:flex-row gap-3 mt-2'>
//                 <Link
//                     to='/'
//                     className='px-6 py-2.5 rounded-full text-white text-sm font-medium tracking-wide transition-opacity duration-200 hover:opacity-90 text-center'
//                     style={{ backgroundColor: sellerPrimaryColor1 + sellerColorSuffixDark }}>
//                     Back To Home Page
//                 </Link>
//                 <Link
//                     to='/shops'
//                     className='px-6 py-2.5 rounded-full text-sm font-medium tracking-wide transition-colors duration-200 text-center border'
//                     style={{ 
//                         borderColor: sellerPrimaryColor1 + sellerColorSuffixDark,
//                         color: sellerPrimaryColor1 + sellerColorSuffixDark,
//                     }}>
//                     Browse {sellerProductPluralTerm}
//                 </Link>
//             </div>
//         </div>
//     );
    
//     useEffect(() => {
//         if (successMessage) {
//             toast.success(successMessage);
//             dispatch(messageClear());
//             dispatch(get_cart_products(userInfo.id));
//         }
//         if (errorMessage) {
//             toast.error(errorMessage);
//             dispatch(messageClear());
//         }
//     }, [successMessage, errorMessage, dispatch, userInfo.id]);

//     // ─── Handlers ──────────────────────────────────────────────────────────────
//     const handleDeleteAll = useCallback(() => {
//         if (!userInfo) { navigate('/login'); return; }
//         (cart_products[0]?.products ?? []).forEach(p => dispatch(delete_cart_product(p._id)));
//     }, [userInfo, cart_products, dispatch, navigate]);

//     const handleMoveToWishlist = useCallback((id) => {
//         if (!userInfo) { navigate('/login'); return; }
//         dispatch(move_from_cart_to_wishlist(id));
//         dispatch(get_cart_products(userInfo.id));
//         dispatch(get_wishlist_products(userInfo.id));
//     }, [userInfo, dispatch, navigate]);

//     const handleQuantityIncrement = useCallback((quantity, stock, cart_id) => {
//         if (quantity + 1 <= stock) dispatch(cart_product_quantity_increment(cart_id));
//     }, [dispatch]);

//     const handleQuantityDecrement = useCallback((quantity, cart_id) => {
//         if (quantity - 1 !== 0) dispatch(cart_product_quantity_decrement(cart_id));
//     }, [dispatch]);

//     const handlePortionSizeChange = useCallback((cart_id, newPortionSize) => {
//         dispatch(cart_product_portion_size_change({ cart_id, newPortionSize }));
//     }, [dispatch]);

//     const handleEventPartChange = useCallback((cart_id, newEventPart) => {
//         dispatch(cart_product_event_part_change({ cart_id, newEventPart }));
//     }, [dispatch]);

//     const redirect = useCallback(() => {
//         navigate('/eventDetails', {
//             state: {
//                 products: cart_products,
//                 price,
//                 shipping_fee,
//                 items: buy_product_item,
//             },
//         });
//     }, [navigate, cart_products, price, shipping_fee, buy_product_item]);

//     // ─── Render ────────────────────────────────────────────────────────────────
//     const hasItems = cart_products.length > 0 || outofstock_products?.length > 0;

//     return (
//         <div>
//             <Header />
//             <section className=''>
//                 <div className=''>
//                     <div className=''>
//                         <ShopBanner
//                             homePage={'Home'} homeLink={'/'}
//                             currentPageTop={`My ${sellerProductPluralTerm}`} currentPageTopLink={''}
//                             currentPageBottom1={`My ${sellerProductPluralTerm}`} currentPageBottomLink1={''}
//                             currentPageBottom2={''} currentPageBottomLink2={''}
//                         />
//                     </div>
//                     {/* ── body start ── */}
//                     <div className='' style={{ backgroundColor: sellerComponentBackgroundColor }}>
//                         <div className='bg-white rounded-2xl w-[85%] lg:w-[90%] md:w-[90%] sm:w-[95%] mx-auto py-0'>
//                             {hasItems ? (
//                                 <div className='border rounded-2xl p-3 flex md-lg:flex-col flex-wrap pt-6 sm:pt-4 gap-6 md-lg:gap-4'
//                                     style={{ 
//                                         backgroundColor: sellerPrimaryColor1 + sellerColorSuffixLight, 
//                                         borderColor: sellerPrimaryColor1 + sellerColorSuffixDark
//                                     }}>
//                                     {/* ── Left: Cart items ── */}
//                                     <div className='flex-1 min-w-0 md-lg:w-full'>
//                                         <div className='flex flex-col gap-4'>
//                                             <div className='bg-white rounded-2xl border p-5 sm:p-3'
//                                                 style={{
//                                                     //backgroundColor: sellerPrimaryColor1 + sellerColorSuffixLight,
//                                                     borderLeft: `6px solid ${sellerPrimaryColor1 + sellerColorSuffixDark}`,
//                                                     borderColor: sellerPrimaryColor1 + sellerColorSuffixDark,
//                                                 }}>
//                                                 <DiagnosticInfo parentPage={'Cart.jsx'} />
//                                                 {/* Header row */}
//                                                 <div className='w-full flex md:flex-col items-start md:items-stretch justify-between gap-4 pb-5 mb-5 border-b border-gray-100'>
//                                                     <div className='flex flex-col gap-2'>
//                                                         <div className='text-2xl md:text-xl font-semibold tracking-tight flex items-center gap-2 flex-wrap'
//                                                             style={{ color: sellerPrimaryColor1 + sellerColorSuffixDark }}>
//                                                             <SiteBadge iconType={'Menu'} iconSize={'24'} badgeSize={'32'} />
//                                                             <span>My Menu</span>
//                                                             <span className='text-sm font-normal'
//                                                                 style={{ color: sellerPrimaryColor1 + sellerColorSuffixMedium }}>
//                                                                 · {buy_product_item} {sellerProductPluralTerm}
//                                                             </span>
//                                                         </div>
//                                                         {/* Sort dropdown */}
//                                                         <div className='flex items-center gap-2 text-sm'>
//                                                             <span className='font-medium whitespace-nowrap'
//                                                                 style={{ color: sellerPrimaryColor1 + sellerColorSuffixMedium }}>
//                                                                 Sort by
//                                                             </span>
//                                                             <select
//                                                                 value={sortMode}
//                                                                 onChange={(e) => setSortMode(e.target.value)}
//                                                                 className='text-sm h-9 px-3 rounded-lg font-medium border border-gray-200 bg-white cursor-pointer focus:outline-none focus:ring-2 transition-shadow'
//                                                                 style={{ 
//                                                                     color: sellerPrimaryColor1 + sellerColorSuffixDark,
//                                                                     backgroundColor: sellerPrimaryColor1 + sellerColorSuffixLight,
//                                                                     borderColor: sellerPrimaryColor1 + sellerColorSuffixDark
//                                                                 }}>
//                                                                 {SORT_OPTIONS.map(opt => (
//                                                                     <option key={opt.value} value={opt.value}>{opt.label}</option>
//                                                                 ))}
//                                                             </select>
//                                                         </div>
//                                                     </div>
//                                                     <button
//                                                         onClick={handleDeleteAll}
//                                                         className='bg-red-500 gap-1 m-1 text-white text-center items-center 
//                                                             justify-center justify-items-center rounded-md px-3 py-1 flex ml-auto md:ml-0'>
//                                                         <MdOutlineRestaurantMenu size={24} className='mt-0.5 mr-0.5' /> Clear My Menu
//                                                     </button>
//                                                 </div>

//                                                 {/* Selected package accordion */}
//                                                 {eventDetails?.selectedSellerPackage && eventDetails.selectedSellerPackage !== 'None' && (
//                                                     <div className='mb-5 rounded-xl border overflow-hidden'
//                                                         style={{ 
//                                                             borderColor: sellerPrimaryColor1 + sellerColorSuffixLight, 
//                                                             color: sellerPrimaryColor1 + sellerColorSuffixDark, 
//                                                             backgroundColor: sellerPrimaryColor1 + sellerColorSuffixLight
//                                                         }}>
//                                                         <Accordion
//                                                             title={sellerPackage?.title}
//                                                             intro={sellerPackage?.intro}
//                                                             pricePerPerson={sellerPackage?.pricePerPerson}
//                                                             minNumberPeople={sellerPackage?.minNumberPeople}
//                                                             description={sellerPackage?.description}
//                                                             showSetSellerPackageButton={false}
//                                                         />
//                                                     </div>
//                                                 )}

//                                                 {/* Product cards */}
//                                                 {cart_products.map((p, i) => (
//                                                     <div
//                                                         key={p._id ?? i}
//                                                         className='grid grid-cols-2 md-lg:grid-cols-1 gap-3'>
//                                                         {sortedProducts.map((pt) => (
//                                                             <CartProduct
//                                                                 key={pt._id}
//                                                                 pt={pt}
//                                                                 onQuantityIncrement={handleQuantityIncrement}
//                                                                 onQuantityDecrement={handleQuantityDecrement}
//                                                                 onPortionSizeChange={handlePortionSizeChange}
//                                                                 onEventPartChange={handleEventPartChange}
//                                                                 onMoveToWishlist={handleMoveToWishlist}
//                                                             />
//                                                         ))}
//                                                     </div>
//                                                 ))}
//                                             </div>

//                                             {/* Out of stock */}
//                                             {outofstock_products?.length > 0 && sellerBoolShowOutOfStock && (
//                                                 <div className='bg-white rounded-2xl border border-gray-100 shadow-sm overflow-hidden'>
//                                                     <div className='px-5 sm:px-3 py-4 border-b border-gray-100'>
//                                                         <h2 className='text-base font-semibold' style={{ color: sellerPrimaryColor1 }}>
//                                                             Out of Stock <span className='text-gray-400 font-normal'>({outofstock_products.length})</span>
//                                                         </h2>
//                                                     </div>
//                                                     <div className='divide-y divide-gray-100'>
//                                                         {outofstock_products.map((p, i) => (
//                                                             <div key={p._id ?? i} className='w-full flex flex-wrap items-center px-5 sm:px-3 py-4'>
//                                                                 <div className='flex sm:w-full gap-3 w-7/12 items-center'>
//                                                                     <img
//                                                                         className='w-[64px] h-[64px] sm:w-[52px] sm:h-[52px] rounded-lg object-cover border border-gray-100 shrink-0'
//                                                                         src={p.products[0].images[0]}
//                                                                         alt={p.products[0].name}
//                                                                     />
//                                                                     <div style={{ color: sellerPrimaryColor1 }}>
//                                                                         <h2 className='text-sm font-semibold'>{p.products[0].name}</h2>
//                                                                         <span className='text-xs text-gray-400'>Brand: {p.products[0].brand}</span>
//                                                                     </div>
//                                                                 </div>
//                                                                 <div className='flex justify-between items-center w-5/12 sm:w-full sm:flex-col-reverse sm:items-stretch sm:gap-3 sm:mt-3'>
//                                                                     <h2 className='text-base font-medium' style={{ color: sellerPrimaryColor1 }}>
//                                                                         {currencyFormat.format(
//                                                                             p.products[0].price -
//                                                                             Math.floor((p.products[0].price * p.products[0].discount) / 100)
//                                                                         )}
//                                                                     </h2>
//                                                                     <div className='flex gap-2 items-center sm:justify-between'>
//                                                                         <div className='flex bg-gray-50 rounded-lg h-8 items-center text-base border border-gray-100'>
//                                                                             <div
//                                                                                 onClick={() => handleQuantityDecrement(p.quantity, p._id)}
//                                                                                 className='px-3 cursor-pointer select-none'
//                                                                                 style={{ color: sellerPrimaryColor1 }}
//                                                                             >−</div>
//                                                                             <div className='px-2 text-sm font-medium' style={{ color: sellerPrimaryColor1 }}>{p.quantity}</div>
//                                                                             <div
//                                                                                 onClick={() => handleQuantityIncrement(p.quantity, p.productInfo?.stock, p._id)}
//                                                                                 className='px-3 cursor-pointer select-none'
//                                                                                 style={{ color: sellerPrimaryColor1 }}
//                                                                             >+</div>
//                                                                         </div>
//                                                                         <button
//                                                                             onClick={() => dispatch(delete_cart_product(p._id))}
//                                                                             className='px-4 py-1.5 text-sm text-white rounded-lg transition-opacity hover:opacity-90'
//                                                                             style={{ backgroundColor: sellerPrimaryColor1 }}>
//                                                                             Delete
//                                                                         </button>
//                                                                     </div>
//                                                                 </div>
//                                                             </div>
//                                                         ))}
//                                                     </div>
//                                                 </div>
//                                             )}
//                                         </div>
//                                     </div>

//                                     {/* ── Right: Summary sidebar ── */}
//                                     <div className='w-[340px] lg:w-[320px] md-lg:w-full'>
//                                         {cart_products.length > 0 && (
//                                             <div className='md-lg:static sticky top-4 bg-white rounded-2xl border border-gray-100 
//                                                 shadow-sm p-5 sm:p-3 flex flex-col gap-4'
//                                                 style={{
//                                                     //backgroundColor: sellerPrimaryColor1 + sellerColorSuffixLight,
//                                                     borderLeft: `6px solid ${sellerPrimaryColor1 + sellerColorSuffixDark}`,
//                                                     borderColor: sellerPrimaryColor1 + sellerColorSuffixDark,
//                                                 }}>
//                                                 <div className='flex items-center gap-2 text-[24px] font-semibold tracking-tight pb-4 border-b border-gray-100'
//                                                     style={{ color: sellerPrimaryColor1 + sellerColorSuffixDark }}>
//                                                     <MdOutlineRestaurantMenu size={32} /> Menu Summary
//                                                 </div>

//                                                 {/* Item count + price */}
//                                                 <div className='flex justify-between items-center text-sm'>
//                                                     <div className='text-gray-500'
//                                                         style={{ color: sellerPrimaryColor1 + sellerColorSuffixDark }}>
//                                                         <span className='font-semibold mr-1'>
//                                                             {buy_product_item}
//                                                         </span>
//                                                         {sellerProductPluralTerm}
//                                                     </div>
//                                                     {sellerBoolShowSitePayments && (
//                                                         <span className='font-medium' style={{ color: sellerPrimaryColor1 + sellerColorSuffixDark }}>
//                                                             {currencyFormat.format(price)}
//                                                         </span>
//                                                     )}
//                                                 </div>

//                                                 {/* Category counts */}
//                                                 <div className='text-xs text-gray-400 leading-relaxed'
//                                                     style={{ color: sellerPrimaryColor1 + sellerColorSuffixMedium }}>
//                                                     {categoryCounts.map(([cat, count], i) => (
//                                                         <span key={cat}>
//                                                             <strong className=''>
//                                                                 {count}</strong> {cat}{i < categoryCounts.length - 1 ? ', ' : ''}
//                                                         </span>
//                                                     ))}
//                                                 </div>

//                                                 {/* Deposit line */}
//                                                 {eventDetails?.depositGiven && (
//                                                     <div className='flex justify-between items-center text-sm text-gray-500 pt-2 border-t border-gray-100'>
//                                                         <span>Deposit</span>
//                                                         <span>−{currencyFormat.format(eventDetails?.depositAmountPaid)}</span>
//                                                     </div>
//                                                 )}

//                                                 {/* <BiSolidCoupon className={`${eventDetails?.couponExpirationDate} ? 'text-[84px]' : 'text-[28px]' `} />  */}
//                                                 {isCouponValid && (
//                                                     <div>
//                                                         <div className='flex items-center gap-1 text-[14px] font-semibold tracking-tight pt-2 border-t border-gray-100'
//                                                             style={{ color: sellerPrimaryColor1 + sellerColorSuffixDark }}>
//                                                             <BiSolidCoupon className={isCouponExpired ? 'text-[62px]' : 'text-[28px]'} />
//                                                             <span>
//                                                                 Coupon {eventDetails?.coupon} {eventDetails?.couponDescription}
//                                                                 <span className={eventDetails?.couponExpirationDate ? '' : 'hidden'}>
//                                                                     <span className=''> expires: </span>
//                                                                     <span className='truncate max-w-[100px]'>
//                                                                         {Moment(eventDetails?.couponExpirationDate).format('MM/DD/yyyy')}
//                                                                     </span>
//                                                                 </span>
//                                                             </span>
//                                                         </div>
//                                                     </div>
//                                                 )}
//                                                 {/* Total */}
//                                                 {sellerBoolShowSitePayments && (
//                                                     <div className='flex justify-between items-center pt-2 border-t border-gray-100'>
//                                                         <span className='text-base font-semibold' style={{ color: sellerPrimaryColor1 + sellerColorSuffixDark }}>Total</span>
//                                                         <span className='text-base font-semibold' style={{ color: sellerPrimaryColor1 + sellerColorSuffixDark }}>
//                                                             {currencyFormat.format(finalPrice)}
//                                                         </span>
//                                                     </div>
//                                                 )}
                                                
//                                                 <button
//                                                     onClick={redirect}
//                                                     className='mt-1 w-full inline-flex items-center justify-center gap-2 rounded-xl text-base font-medium text-white py-3 transition-opacity duration-200 hover:opacity-90'
//                                                     style={{ backgroundColor: sellerPrimaryColor1 + sellerColorSuffixDark }}>
//                                                     <TbListDetails size={18} /> Proceed to Event Details
//                                                 </button>
//                                             </div>
//                                         )}
//                                     </div>
//                                 </div>
//                             ) : (
//                                 <div>
//                                     <EmptyShoppingCart
//                                         sellerPrimaryColor1={sellerPrimaryColor1}
//                                         sellerProductPluralTerm={sellerProductPluralTerm}
//                                     />
//                                 </div>
//                             )}
//                         </div>
//                     </div>
//                 </div>
//                 {/* ── body end ── */}
//             </section>
//             <Footer />
//         </div>
//     );
// };

// export default Cart;




//before redesign
// import React, { useEffect, useCallback, useMemo, useState } from 'react';
// import { useDispatch, useSelector } from 'react-redux';
// import { Link, useNavigate } from 'react-router-dom';

// import { IoIosArrowForward } from "react-icons/io";
// import { TbListDetails } from "react-icons/tb";
// import { MdOutlineRestaurantMenu } from "react-icons/md";
// import { FiShoppingCart } from "react-icons/fi";
// import { FaRegTrashAlt, FaRegHeart } from "react-icons/fa";
// import { RiShoppingCartLine } from "react-icons/ri";

// import Header from '../components/Header';
// import Footer from '../components/Footer';
// import ShopBanner from '../components/ShopBanner';
// import CartProduct from '../components/CartProduct';
// import Accordion from '../components/Accordion';
// import GetSellerConfig from '../components/GetSellerConfig';
// import SiteBadge from '../components/SiteBadge';

// import {
//     get_cart_products,
//     get_wishlist_products,
//     delete_cart_product,
//     messageClear,
//     cart_product_quantity_increment,
//     move_from_cart_to_wishlist,
//     cart_product_quantity_decrement,
//     cart_product_portion_size_change,
//     cart_product_event_part_change,
// } from '../store/reducers/cartReducer';
// import { get_product_deposit_details } from '../store/reducers/homeReducer';
// import { get_event_details } from '../store/reducers/eventDetailsReducer';
// import { get_one_sellerPackage } from '../store/reducers/sellerPackageReducer';

// import { currencyFormat } from '../components/CurrencyFormat';
// import toast from 'react-hot-toast';
// import config from '../config';

// const Cart = () => {
//     const dispatch = useDispatch();
//     const navigate = useNavigate();

//     // ─── Config ────────────────────────────────────────────────────────────────
//     const sellerFrontendURL = config.STR_FRONTEND_URL;
//     const sellerEnvironment = config.STR_ENVIRONMENT;
//     const sellerBoolShowOutOfStock = config.BOOL_SHOW_PRODUCT_OUT_OF_STOCK;

//     // ─── Redux state ───────────────────────────────────────────────────────────
//     const { seller } = useSelector(state => state.seller);
//     const { userInfo } = useSelector(state => state.auth);
//     const {
//         cart_products,
//         successMessage,
//         errorMessage,
//         buy_product_item,
//         price,
//         shipping_fee,
//         outofstock_products,
//     } = useSelector(state => state.cart);

//     const { depositProduct } = useSelector(state => state.home);
//     const { eventDetails } = useSelector(state => state.eventDetails);
//     const { sellerPackage } = useSelector(state => state.sellerPackage);

//     const { 
//         sellerId, sellerPrimaryColor1, sellerPrimaryColor2, sellerSecondaryColor1, sellerSecondaryColor2,
//         sellerColorSuffixDark, sellerColorSuffixMedium, sellerColorSuffixLight, sellerComponentBackgroundColor,
//         sellerProductPluralTerm, sellerBoolShowSitePayments, sellerBoolShowQuantities, sellerBoolShowCuisineType,
//     } = GetSellerConfig();

//     // ─── Derived values ────────────────────────────────────────────────────────
//     const finalPrice = eventDetails?.depositGiven
//         ? price - (depositProduct?.price ?? 0)
//         : price;

//     // Category counts rendered as React elements (no dangerouslySetInnerHTML)
//     const categoryCounts = useMemo(() => {
//         const products = cart_products[0]?.products ?? [];
//         const counts = products.reduce((acc, product) => {
//             const cat = product.productInfo?.category ?? 'Unknown';
//             acc[cat] = (acc[cat] || 0) + 1;
//             return acc;
//         }, {});
//         return Object.entries(counts).sort(([a], [b]) => a.localeCompare(b));
//     }, [cart_products]);

//     // ─── Sort mode ─────────────────────────────────────────────────────────────
//     const SORT_OPTIONS = [
//         { value: 'category_name', label: 'Category, Name' },
//         { value: 'name_category', label: 'Name, Category' },
//         { value: 'eventpart_name', label: 'Event Part, Name' },
//     ];
//     const [sortMode, setSortMode] = useState('category_name');

//     const sortedProducts = useMemo(() => {
//         return [...(cart_products[0]?.products ?? [])].sort((a, b) => {
//             const nameA = a.productInfo?.name ?? '';
//             const nameB = b.productInfo?.name ?? '';
//             const catA  = a.productInfo?.category ?? '';
//             const catB  = b.productInfo?.category ?? '';
//             const evtA  = a.eventPart ?? '';
//             const evtB  = b.eventPart ?? '';

//             if (sortMode === 'category_name') {
//                 return catA !== catB ? catA.localeCompare(catB) : nameA.localeCompare(nameB);
//             }
//             if (sortMode === 'name_category') {
//                 return nameA !== nameB ? nameA.localeCompare(nameB) : catA.localeCompare(catB);
//             }
//             if (sortMode === 'eventpart_name') {
//                 return evtA !== evtB ? evtA.localeCompare(evtB) : nameA.localeCompare(nameB);
//             }
//             return 0;
//         });
//     }, [cart_products, sortMode]);

//     // ─── Effects ───────────────────────────────────────────────────────────────
//     useEffect(() => {
//         dispatch(get_event_details(userInfo.id));
//     }, [userInfo.id, dispatch]);

//     useEffect(() => {
//         dispatch(get_product_deposit_details(sellerFrontendURL));
//         dispatch(get_cart_products(userInfo.id));
//     }, [dispatch, sellerFrontendURL, userInfo.id]);

//     useEffect(() => {
//         if (eventDetails?.selectedSellerPackage) {
//             dispatch(get_one_sellerPackage({
//                 title: eventDetails.selectedSellerPackage,
//                 webSiteOrigin: sellerFrontendURL,
//             }));
//         }
//     }, [eventDetails?.selectedSellerPackage, sellerFrontendURL, dispatch]);

//     const EmptyShoppingCart = ({ sellerPrimaryColor1, sellerProductPluralTerm }) => (
//         <div className='flex flex-col items-center justify-center py-16 gap-4'>
//             <div className='flex gap-4'>
//                 <RiShoppingCartLine size={48} style={{ color: sellerPrimaryColor1 + sellerColorSuffixMedium }} />
//                 <MdOutlineRestaurantMenu size={48} style={{ color: sellerPrimaryColor1+ sellerColorSuffixMedium }} />
//             </div>
//             <p className='text-lg font-semibold' style={{ color: sellerPrimaryColor1 + sellerColorSuffixMedium }}>
//                 My {sellerProductPluralTerm} Is Empty
//             </p>
//             <div className='grid grid-cols-2 sm:grid-cols-1 gap-4'>
//                 <Link
//                     to='/'
//                     className='px-4 py-2 rounded-md text-white text-md'
//                     style={{ backgroundColor: sellerPrimaryColor1 + sellerColorSuffixDark }}>
//                     Back To Home Page
//                 </Link>
//                 <Link
//                     to='/shops'
//                     className='px-4 py-2 rounded-md text-white text-md'
//                     style={{ backgroundColor: sellerPrimaryColor1 + sellerColorSuffixDark }}>
//                     Browse {sellerProductPluralTerm}
//                 </Link>
//             </div>
//         </div>
//     );
    
//     useEffect(() => {
//         if (successMessage) {
//             toast.success(successMessage);
//             dispatch(messageClear());
//             dispatch(get_cart_products(userInfo.id));
//         }
//         if (errorMessage) {
//             toast.error(errorMessage);
//             dispatch(messageClear());
//         }
//     }, [successMessage, errorMessage, dispatch, userInfo.id]);

//     // ─── Handlers ──────────────────────────────────────────────────────────────
//     const handleDeleteAll = useCallback(() => {
//         if (!userInfo) { navigate('/login'); return; }
//         (cart_products[0]?.products ?? []).forEach(p => dispatch(delete_cart_product(p._id)));
//     }, [userInfo, cart_products, dispatch, navigate]);

//     const handleMoveToWishlist = useCallback((id) => {
//         if (!userInfo) { navigate('/login'); return; }
//         dispatch(move_from_cart_to_wishlist(id));
//         dispatch(get_cart_products(userInfo.id));
//         dispatch(get_wishlist_products(userInfo.id));
//     }, [userInfo, dispatch, navigate]);

//     const handleQuantityIncrement = useCallback((quantity, stock, cart_id) => {
//         if (quantity + 1 <= stock) dispatch(cart_product_quantity_increment(cart_id));
//     }, [dispatch]);

//     const handleQuantityDecrement = useCallback((quantity, cart_id) => {
//         if (quantity - 1 !== 0) dispatch(cart_product_quantity_decrement(cart_id));
//     }, [dispatch]);

//     const handlePortionSizeChange = useCallback((cart_id, newPortionSize) => {
//         dispatch(cart_product_portion_size_change({ cart_id, newPortionSize }));
//     }, [dispatch]);

//     const handleEventPartChange = useCallback((cart_id, newEventPart) => {
//         dispatch(cart_product_event_part_change({ cart_id, newEventPart }));
//     }, [dispatch]);

//     const redirect = useCallback(() => {
//         navigate('/eventDetails', {
//             state: {
//                 products: cart_products,
//                 price,
//                 shipping_fee,
//                 items: buy_product_item,
//             },
//         });
//     }, [navigate, cart_products, price, shipping_fee, buy_product_item]);

//     // ─── Render ────────────────────────────────────────────────────────────────
//     const hasItems = cart_products.length > 0 || outofstock_products?.length > 0;

//     return (
//         <div>
//             <Header />
//             <section className=''>
//                 {/*  bg-[#eeeeee] w-[85%] lg:w-[90%] md:w-[90%] sm:w-[90%] mx-auto py-0 */}
//                 <div className=''>
//                     <div className=''>
//                         <ShopBanner
//                             homePage={'Home'}
//                             homeLink={'/'}
//                             currentPageTop={`My ${sellerProductPluralTerm}`}
//                             currentPageTopLink={''}
//                             currentPageBottom1={`My ${sellerProductPluralTerm}`}
//                             currentPageBottomLink1={''}
//                             currentPageBottom2={''}
//                             currentPageBottomLink2={''}
//                         />
//                     </div>
//                     {/* body start  */}
//                     <div className='' style={{ backgroundColor: sellerComponentBackgroundColor }}>
//                         <div className='w-[85%] lg:w-[90%] md:w-[90%] sm:w-[90%] mx-auto py-0'>
//                             {hasItems ? (
//                                 <div className='flex flex-wrap pt-4 '>
//                                     {/* ── Left: Cart items ── */}
//                                     <div className='w-[67%] md-lg:w-full'>
//                                         <div className='pr-2 md-lg:pr-0'>
//                                             <div className='flex flex-col gap-1 items-center justify-center place-content-center bg-white'>
//                                                 <div className='p-3 w-full border rounded-xl' 
//                                                     style={{ borderColor: sellerPrimaryColor1 + sellerColorSuffixDark }}>

//                                                     {/* Dev debug panel */}
//                                                     {sellerEnvironment === 'Dev' && (
//                                                         <div className='text-[14px]'>
//                                                             <div>eventDetails?._id</div>
//                                                             <div>&quot;_id&quot;: ObjectId(&quot;{eventDetails?._id}&quot;)</div>
//                                                             <div>depositGiven: {eventDetails?.depositGiven?.toString()}</div>
//                                                             <div>showPayments: {sellerBoolShowSitePayments.toString()}</div>
//                                                         </div>
//                                                     )}

//                                                     {/* Header row */}
//                                                     <div
//                                                         className='w-full grid grid-cols-2 lg:grid-cols-2 md:grid-cols-2 sm:grid-cols-1 border-none'
//                                                         style={{ color: sellerPrimaryColor1 + sellerColorSuffixDark }}>
//                                                         <div>
//                                                             <div className='text-xl font-semibold flex gap-1'>
//                                                                 <SiteBadge iconType={'Menu'} iconSize={'24'} badgeSize={'32'}  />
//                                                                 My Menu, {buy_product_item} {sellerProductPluralTerm}
//                                                             </div>
//                                                             {/* Sort dropdown */}
//                                                             <div className='ml-2 mt-1 flex items-center gap-2 text-sm'>
//                                                                 <span className='font-medium whitespace-nowrap'>Sort by:</span>
//                                                                 <select
//                                                                     value={sortMode}
//                                                                     onChange={(e) => setSortMode(e.target.value)}
//                                                                     className='text-[13px] h-[28px] px-1.5 rounded-md font-semibold border cursor-pointer'
//                                                                     style={{ 
//                                                                         borderColor: sellerPrimaryColor1 + sellerColorSuffixDark, 
//                                                                         color: sellerPrimaryColor1 + sellerColorSuffixDark, 
//                                                                         backgroundColor: sellerPrimaryColor1 + sellerColorSuffixLight
//                                                                     }}>
//                                                                     {SORT_OPTIONS.map(opt => (
//                                                                         <option key={opt.value} value={opt.value}>{opt.label}</option>
//                                                                     ))}
//                                                                 </select>
//                                                             </div>
//                                                         </div>
//                                                         <div className='w-full border-none justify-end items-end justify-items-end
//                                                             sm:justify-self-center sm:justify-items-center'>
//                                                             <button
//                                                                 onClick={handleDeleteAll}
//                                                                 className='bg-red-500 m-1 text-white text-xl font-semibold rounded-md px-3 py-1 flex'>
//                                                                 <MdOutlineRestaurantMenu className='mr-1 mt-1' /> Clear My Menu
//                                                             </button>
//                                                         </div>
//                                                     </div>

//                                                     {/* Selected package accordion */}
//                                                     {eventDetails?.selectedSellerPackage && eventDetails.selectedSellerPackage !== 'None' && (
//                                                         <div
//                                                             className='ml-4 mr-4 mb-2 mt-2 rounded-lg border xs:w-[89%] sm:w-[93%] lg:w-[95%]'
//                                                             style={{ 
//                                                                 borderColor: sellerPrimaryColor1 + sellerColorSuffixDark, 
//                                                                 color: sellerPrimaryColor1 + sellerColorSuffixDark, 
//                                                                 backgroundColor: sellerPrimaryColor1 + sellerColorSuffixLight
//                                                             }}>
//                                                             <Accordion
//                                                                 title={sellerPackage?.title}
//                                                                 intro={sellerPackage?.intro}
//                                                                 pricePerPerson={sellerPackage?.pricePerPerson}
//                                                                 minNumberPeople={sellerPackage?.minNumberPeople}
//                                                                 description={sellerPackage?.description}
//                                                                 showSetSellerPackageButton={false}
//                                                             />
//                                                         </div>
//                                                     )}

//                                                     {/* Product cards */}
//                                                     {cart_products.map((p, i) => (
//                                                         <div
//                                                             key={p._id ?? i}
//                                                             className='grid grid-cols-2 lg:grid-cols-2 md:grid-cols-2 sm:grid-cols-1 
//                                                             bg-white m-4 gap-2'>
//                                                             {sortedProducts.map((pt) => (
//                                                                 <CartProduct
//                                                                     key={pt._id}
//                                                                     pt={pt}
//                                                                     onQuantityIncrement={handleQuantityIncrement}
//                                                                     onQuantityDecrement={handleQuantityDecrement}
//                                                                     onPortionSizeChange={handlePortionSizeChange}
//                                                                     onEventPartChange={handleEventPartChange}
//                                                                     onMoveToWishlist={handleMoveToWishlist}
//                                                                 />
//                                                             ))}
//                                                         </div>
//                                                     ))}

//                                                     {/* Out of stock */}
//                                                     {outofstock_products?.length > 0 && sellerBoolShowOutOfStock && (
//                                                         <div className='flex flex-col gap-3'>
//                                                             <div className='bg-white p-4'>
//                                                                 <h2 className='text-md font-semibold' style={{ color: sellerPrimaryColor1 }}>
//                                                                     Out of Stock ({outofstock_products.length})
//                                                                 </h2>
//                                                             </div>
//                                                             <div className='border bg-white p-4'>
//                                                                 {outofstock_products.map((p, i) => (
//                                                                     <div key={p._id ?? i} className='w-full flex flex-wrap'>
//                                                                         <div className='flex sm:w-full gap-2 w-7/12'>
//                                                                             <div className='flex gap-2 justify-start items-center'>
//                                                                                 <img
//                                                                                     className='w-[80px] h-[80px]'
//                                                                                     src={p.products[0].images[0]}
//                                                                                     alt={p.products[0].name}
//                                                                                 />
//                                                                                 <div className='pr-4' style={{ color: sellerPrimaryColor1 }}>
//                                                                                     <h2 className='text-md font-semibold'>{p.products[0].name}</h2>
//                                                                                     <span className='text-sm'>Brand: {p.products[0].brand}</span>
//                                                                                 </div>
//                                                                             </div>
//                                                                         </div>
//                                                                         <div className='flex justify-between w-5/12 sm:w-full sm:mt-3'>
//                                                                             <div className='pl-4 sm:pl-0'>
//                                                                                 <h2 className='text-lg' style={{ color: sellerPrimaryColor1 }}>
//                                                                                     {currencyFormat.format(
//                                                                                         p.products[0].price -
//                                                                                         Math.floor((p.products[0].price * p.products[0].discount) / 100)
//                                                                                     )}
//                                                                                 </h2>
//                                                                             </div>
//                                                                             <div className='flex gap-2 flex-col'>
//                                                                                 <div className='flex bg-slate-200 h-[30px] justify-center items-center text-xl'>
//                                                                                     <div
//                                                                                         onClick={() => handleQuantityDecrement(p.quantity, p._id)}
//                                                                                         className='px-3 cursor-pointer'
//                                                                                         style={{ color: sellerPrimaryColor1 }}
//                                                                                     >-</div>
//                                                                                     <div className='px-3' style={{ color: sellerPrimaryColor1 }}>{p.quantity}</div>
//                                                                                     <div
//                                                                                         onClick={() => handleQuantityIncrement(p.quantity, p.productInfo?.stock, p._id)}
//                                                                                         className='px-3 cursor-pointer'
//                                                                                         style={{ color: sellerPrimaryColor1 }}
//                                                                                     >+</div>
//                                                                                 </div>
//                                                                                 <button
//                                                                                     onClick={() => dispatch(delete_cart_product(p._id))}
//                                                                                     className='px-5 py-[3px] text-white rounded-md'
//                                                                                     style={{ backgroundColor: sellerPrimaryColor1 }}>
//                                                                                     Delete
//                                                                                 </button>
//                                                                             </div>
//                                                                         </div>
//                                                                     </div>
//                                                                 ))}
//                                                             </div>
//                                                         </div>
//                                                     )}
//                                                 </div>
//                                             </div>
//                                         </div>
//                                     </div>

//                                     {/* ── Right: Summary sidebar ── */}
//                                     <div className='w-[33%] md-lg:w-full'>
//                                         <div className='pl-3 md-lg:pl-0 md-lg:mt-5'>
//                                             {cart_products.length > 0 && (
//                                                 <div className='bg-white rounded-xl'>
//                                                     <div
//                                                         className='p-3 flex flex-col gap-2 border rounded-xl '
//                                                         style={{ 
//                                                             color: sellerPrimaryColor1 + sellerColorSuffixDark, 
//                                                             borderColor: sellerPrimaryColor1 + sellerColorSuffixDark, 
//                                                             backgroundColor: sellerPrimaryColor1 + sellerColorSuffixLight 
//                                                         }}>
//                                                         <div className='text-xl font-bold flex border-none border-black'>
//                                                             <MdOutlineRestaurantMenu size={32} className='mr-1 mt-0' /> Menu Summary
//                                                         </div>

//                                                         {/* Item count + price */}
//                                                         <div className='flex ml-2 justify-between items-center'>
//                                                             <div>
//                                                                 <span className='font-bold mr-1'>{buy_product_item}</span>
//                                                                 {sellerProductPluralTerm}
//                                                             </div>
//                                                             {sellerBoolShowSitePayments && (
//                                                                 <span className='ml-2'>{currencyFormat.format(price)}</span>
//                                                             )}
//                                                         </div>

//                                                         {/* Category counts — no dangerouslySetInnerHTML */}
//                                                         <div className='ml-2 border-none border-black'>
//                                                             {categoryCounts.map(([cat, count], i) => (
//                                                                 <span key={cat}>
//                                                                     <strong>{count}</strong> {cat}{i < categoryCounts.length - 1 ? ', ' : ''}
//                                                                 </span>
//                                                             ))}
//                                                         </div>

//                                                         {/* Deposit line */}
//                                                         {eventDetails?.depositGiven && (
//                                                             <div className='flex ml-2 justify-between items-center'>
//                                                                 <span>Deposit</span>
//                                                                 <span>-{currencyFormat.format(depositProduct?.price)}</span>
//                                                             </div>
//                                                         )}

//                                                         {/* Total */}
//                                                         {sellerBoolShowSitePayments && (
//                                                             <div className='flex ml-2 justify-between items-center'>
//                                                                 <span className='text-lg'>Total</span>
//                                                                 <span className='text-lg'>{currencyFormat.format(finalPrice)}</span>
//                                                             </div>
//                                                         )}

//                                                         <button
//                                                             onClick={redirect}
//                                                             className='px-5 py-[6px] flex rounded-lg text-lg text-white justify-center items-center'
//                                                             style={{ backgroundColor: sellerPrimaryColor1 + sellerColorSuffixDark }}>
//                                                             <TbListDetails className='mr-1 mt-0' /> Proceed to Event Details
//                                                         </button>
//                                                     </div>
//                                                 </div>
//                                             )}
//                                         </div>
//                                     </div>
//                                 </div>
//                             ) : (
//                                 <div>
//                                     <EmptyShoppingCart
//                                         primaryColor={sellerPrimaryColor1}
//                                         productPluralTerm={sellerProductPluralTerm}
//                                     />
//                                 </div>
//                             )}
//                         </div>
//                     </div>
//                 </div>
                    
//                 {/* ── body end ── */}
                
//             </section>
//             <Footer />
//         </div>
//     );
// };

// export default Cart;







